import { useParams } from 'react-router-dom';

import usePermissions from '../containers/common/PermissionProvider/usePermissions';
import useUser from '../containers/common/UserProvider/useUser';
import useFetch from './useFetch';

export default function useSeller() {
  // Hooks
  const { sellerSlug } = useParams();
  const { isAuthenticated } = useUser();
  const { permissions } = usePermissions();
  const { isSeller } = permissions;

  // Constants
  const endpoints = {
    seller: `/sellers/${sellerSlug}/`,
    sellerPermissions: `/sellers/${sellerSlug}/permissions/`,
    schoolManagement: `/sellers/${sellerSlug}/school-management/`,
  };

  // Fetch
  const { data: dataPermissions, error } = useFetch([
    isAuthenticated && sellerSlug ? endpoints.sellerPermissions : null,
  ]);
  const { data, isLoading, mutate } = useFetch([
    isAuthenticated && isSeller && sellerSlug ? endpoints.seller : null,
  ]);
  const {
    data: dataSchoolManagement,
    isLoading: schoolManagementLoading,
    mutate: refreshSchoolManagement,
  } = useFetch([isAuthenticated && isSeller && sellerSlug ? endpoints.schoolManagement : null]);

  return {
    error,
    seller: data,
    sellerLoading: isLoading,
    sellerPermissions: dataPermissions?.permissions,
    refresh: mutate,
    schoolManagement: dataSchoolManagement,
    schoolManagementLoading,
    refreshSchoolManagement,
  };
}
